module.exports = [{"code":1,"name":"布控中"},{"code":2,"name":"布控到期"},{"code":3,"name":"撤控"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/dispositionStatus.json
// module id = MT5s
// module chunks = 11